import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

export interface IFileUploadStateData {
  uploadProgress: number | null;
  cancelUpload(): Promise<void>;
  hasError?: boolean;
}

interface IFileUploadStateLocalStore {
  uploadFileData: IFileUploadStateData | null;
  hasError: boolean;
  isWaitingUploadProcess: boolean;
  isUploadProcess: boolean;
  uploadProgress: number | null;
  setUploadFileData(uploadFileData: IFileUploadStateData): void;
  cancelUpload(): Promise<void>;
}

export const useFileUploadStatePresenter = (
  uploadFileData: IFileUploadStateData
): IFileUploadStateLocalStore => {
  const presenter = useLocalObservable<IFileUploadStateLocalStore>(() => ({
    uploadFileData: null,

    get hasError(): boolean {
      return Boolean(presenter.uploadFileData?.hasError);
    },

    get isWaitingUploadProcess(): boolean {
      return !presenter.hasError && presenter.uploadFileData?.uploadProgress === 0;
    },

    get uploadProgress(): number | null {
      if (!presenter.uploadFileData) {
        return null;
      }
      return presenter.uploadFileData.uploadProgress;
    },

    get isUploadProcess(): boolean {
      return !!presenter.uploadProgress && Number(presenter.uploadProgress) > 0;
    },

    setUploadFileData(uploadFileData: IFileUploadStateData): void {
      presenter.uploadFileData = uploadFileData;
    },

    async cancelUpload(): Promise<void> {
      await presenter.uploadFileData?.cancelUpload?.();
    },
  }));

  useEffect(() => {
    presenter.setUploadFileData(uploadFileData);
  }, [uploadFileData]);

  return presenter;
};
